(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[13],{

/***/ "/a9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("lwsE");

var _createClass = __webpack_require__("W8MJ");

var _inherits = __webpack_require__("7W2i");

var _possibleConstructorReturn = __webpack_require__("a1gu");

var _getPrototypeOf = __webpack_require__("Nsbk");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _head = _interopRequireDefault(__webpack_require__("8Kt/"));

var statusCodes = {
  400: 'Bad Request',
  404: 'This page could not be found',
  405: 'Method Not Allowed',
  500: 'Internal Server Error'
};

function _getInitialProps(_ref) {
  var res = _ref.res,
      err = _ref.err;
  var statusCode = res && res.statusCode ? res.statusCode : err ? err.statusCode : 404;
  return {
    statusCode: statusCode
  };
}
/**
* `Error` component used for handling errors.
*/


var Error = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(Error, _react$default$Compon);

  var _super = _createSuper(Error);

  function Error() {
    _classCallCheck(this, Error);

    return _super.apply(this, arguments);
  }

  _createClass(Error, [{
    key: "render",
    value: function render() {
      var statusCode = this.props.statusCode;
      var title = this.props.title || statusCodes[statusCode] || 'An unexpected error has occurred';
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.error
      }, /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, statusCode, ": ", title)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("style", {
        dangerouslySetInnerHTML: {
          __html: 'body { margin: 0 }'
        }
      }), statusCode ? /*#__PURE__*/_react["default"].createElement("h1", {
        style: styles.h1
      }, statusCode) : null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.desc
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: styles.h2
      }, title, "."))));
    }
  }]);

  return Error;
}(_react["default"].Component);

exports["default"] = Error;
Error.displayName = 'ErrorPage';
Error.getInitialProps = _getInitialProps;
Error.origGetInitialProps = _getInitialProps;
var styles = {
  error: {
    color: '#000',
    background: '#fff',
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
    height: '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  desc: {
    display: 'inline-block',
    textAlign: 'left',
    lineHeight: '49px',
    height: '49px',
    verticalAlign: 'middle'
  },
  h1: {
    display: 'inline-block',
    borderRight: '1px solid rgba(0, 0, 0,.3)',
    margin: 0,
    marginRight: '20px',
    padding: '10px 23px 10px 0',
    fontSize: '24px',
    fontWeight: 500,
    verticalAlign: 'top'
  },
  h2: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 'inherit',
    margin: 0,
    padding: 0
  }
};

/***/ }),

/***/ "1A3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QKO/");
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(rebass__WEBPACK_IMPORTED_MODULE_2__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var Title = function Title(props) {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(rebass__WEBPACK_IMPORTED_MODULE_2__["Heading"], _objectSpread(_objectSpread({
    as: "h1"
  }, props), {}, {
    fontFamily: "serif",
    mx: [2, 4],
    my: [2, 4],
    fontSize: [6, 7],
    fontWeight: "normal",
    textAlign: "center",
    lineHeight: "copy"
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),

/***/ "CgG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vOnD");
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QKO/");
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(rebass__WEBPACK_IMPORTED_MODULE_3__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var _StyledHeading = Object(styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(rebass__WEBPACK_IMPORTED_MODULE_3__["Heading"]).withConfig({
  displayName: "Subheadline___StyledHeading",
  componentId: "xon3uo-0"
})(["border-bottom:5px solid ", ";max-width:", ";"], function (p) {
  return p.theme.highlight;
}, function (p) {
  return p.theme.smalerMaxWidth;
});

var Subheadline = function Subheadline(props) {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_StyledHeading, _objectSpread(_objectSpread({
    as: "h3"
  }, props), {}, {
    fontFamily: "serif",
    mx: "auto",
    my: [2, 4],
    fontSize: [4, 5],
    fontWeight: "normal" // textAlign="center"
    ,
    lineHeight: "copy"
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Subheadline);

/***/ }),

/***/ "GwuW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const React = __webpack_require__("q1tI");
const ServerContextContext = __webpack_require__("jVCk");

/**
 * A [React](https://reactjs.org) hook to access the
 * [server context]{@link ServerContextContext}.
 * @kind function
 * @name useServerContext
 * @returns {ServerContext|undefined} [Node.js](https://nodejs.org) HTTP server context, or `undefined` if client rendering.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { useServerContext } from 'next-server-context';
 * ```
 *
 * ```js
 * import useServerContext from 'next-server-context/public/useServerContext.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { useServerContext } = require('next-server-context');
 * ```
 *
 * ```js
 * const useServerContext = require('next-server-context/public/useServerContext.js');
 * ```
 * @example <caption>A [React](https://reactjs.org) component that sets the [Next.js](https://nextjs.org) page’s HTTP status code when server side rendered.</caption>
 * ```jsx
 * import useServerContext from 'next-server-context/public/useServerContext.js';
 *
 * export default function ErrorMissing() {
 *   const serverContext = useServerContext();
 *   if (serverContext) serverContext.response.statusCode = 404;
 *   return (
 *     <section>
 *       <h1>Error 404</h1>
 *       <p>Something is missing.</p>
 *     </section>
 *   );
 * }
 * ```
 */
module.exports = function useServerContext() {
  return React.useContext(ServerContextContext);
};


/***/ }),

/***/ "KMK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_POSTS_QUERY; });
/* harmony import */ var _babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("h4VS");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTCR");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_1__);


function _templateObject() {
  var data = Object(_babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(["\n  query ALL_POSTS_QUERY($cursor: String, $first: Int = 10) {\n    posts: posts(first: $first, after: $cursor) {\n      edges {\n        node {\n          revisionCount\n          id\n          title\n          link: uri\n          date\n          commentCount\n          featuredImage {\n            node {\n              mediaDetails {\n                sizes {\n                  name\n                  sourceUrl\n                  width\n                  height\n                }\n              }\n            }\n          }\n          categories {\n            edges {\n              node {\n                name\n                slug\n              }\n            }\n          }\n          excerpt(format: RAW)\n          author {\n            node {\n              name\n              slug\n            }\n          }\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}


var ALL_POSTS_QUERY = graphql_tag__WEBPACK_IMPORTED_MODULE_1___default()(_templateObject());

/***/ }),

/***/ "MRay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "a804ns-0"
})(["max-width:", ";margin:auto;padding:2rem;"], function (props) {
  return props.theme.maxWidth;
});
/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),

/***/ "SLuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var ArticleContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "ArticleContent",
  componentId: "sc-1k7q9q3-0"
})(["padding-top:4rem;max-width:", ";margin:0 auto;@media screen and (max-width:500px){padding-top:2rem;}"], function (props) {
  return props.theme.maxWidth;
});
/* harmony default export */ __webpack_exports__["a"] = (ArticleContent);

/***/ }),

/***/ "Y0NT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./lib/graphql/allPostsQuery.js
var allPostsQuery = __webpack_require__("KMK3");

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__("ttZb");

// CONCATENATED MODULE: ./lib/hooks/useAllPosts.js


function useAllPosts() {
  var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return Object(react_hooks_esm["c" /* useQuery */])(allPostsQuery["a" /* ALL_POSTS_QUERY */], {
    variables: {
      first: first
    }
  });
}
// EXTERNAL MODULE: ./components/Layout/Wrapper.js
var Wrapper = __webpack_require__("MRay");

// EXTERNAL MODULE: ./components/Atoms/Subheadline.js
var Subheadline = __webpack_require__("CgG0");

// EXTERNAL MODULE: ./node_modules/rebass/dist/index.js
var dist = __webpack_require__("QKO/");

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__("kriW");

// EXTERNAL MODULE: ./components/Molecules/Teaser.js + 1 modules
var Teaser = __webpack_require__("ln4y");

// EXTERNAL MODULE: ./components/Atoms/ArticleContent.js
var ArticleContent = __webpack_require__("SLuz");

// CONCATENATED MODULE: ./pages/_error.js






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var Article = styled_components_browser_esm["default"].article.withConfig({
  displayName: "_error__Article",
  componentId: "sc-1oulmnr-0"
})(["padding-top:4rem;"]);

var _StyledBox = Object(styled_components_browser_esm["default"])(dist["Box"]).withConfig({
  displayName: "_error___StyledBox",
  componentId: "sc-1oulmnr-1"
})(["background-image:url(\"/404.jpg\");background-size:cover;color:white;"]);

var _StyledHeading = Object(styled_components_browser_esm["default"])(dist["Heading"]).withConfig({
  displayName: "_error___StyledHeading",
  componentId: "sc-1oulmnr-2"
})(["text-shadow:0 2px 0 black;max-width:", ";"], function (props) {
  return props.theme.maxWidth;
});

var _error_Title = function Title(props) {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledBox, {
    py: 4,
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledHeading, _objectSpread(_objectSpread({
      as: "h1"
    }, props), {}, {
      fontFamily: "serif",
      my: [5, 7],
      mx: "auto",
      fontSize: [4, 7],
      fontWeight: "normal",
      textAlign: "center",
      lineHeight: "copy"
    }))
  });
};

var _error_FourOhFour = function FourOhFour() {
  var _data$posts, _data$posts2, _data$posts2$edges;

  var _useAllPosts = useAllPosts(4),
      data = _useAllPosts.data,
      loading = _useAllPosts.loading;

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(Article, {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(_error_Title, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(message["a" /* default */], {
        id: "404.headline",
        defaultMessage: "Hey, der von Dir gesuchte Inhalt existiert leider nicht mehr."
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(ArticleContent["a" /* default */], {
      children: !loading && /*#__PURE__*/Object(jsx_runtime["jsxs"])(Wrapper["a" /* default */], {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(Subheadline["a" /* default */], {
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(message["a" /* default */], {
            id: "404.teaser",
            defaultMessage: "Probier doch einen unserer neuesten Artikel"
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(dist["Flex"], {
          flexWrap: "wrap",
          mx: -2,
          children: (data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.edges) && (data === null || data === void 0 ? void 0 : (_data$posts2 = data.posts) === null || _data$posts2 === void 0 ? void 0 : (_data$posts2$edges = _data$posts2.edges) === null || _data$posts2$edges === void 0 ? void 0 : _data$posts2$edges.map(function (post) {
            return /*#__PURE__*/Object(jsx_runtime["jsx"])(Teaser["a" /* default */], {
              post: post.node
            }, "lates-".concat(post.node.postId));
          }))
        })]
      })
    })]
  });
};

/* harmony default export */ var _error = __webpack_exports__["default"] = (_error_FourOhFour);

/***/ }),

/***/ "eomm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/a9y")


/***/ }),

/***/ "ln4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Teaser; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/rebass/dist/index.js
var dist = __webpack_require__("QKO/");

// EXTERNAL MODULE: ./util/link.js
var util_link = __webpack_require__("XEHS");

// EXTERNAL MODULE: ./node_modules/react-simple-img/lib/index.js
var lib = __webpack_require__("Uty7");

// EXTERNAL MODULE: ./lib/wordpress.js
var wordpress = __webpack_require__("xWpn");

// EXTERNAL MODULE: ./util/markup.js
var markup = __webpack_require__("jZu3");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./components/Atoms/Headline.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var _StyledHeading = Object(styled_components_browser_esm["default"])(dist["Heading"]).withConfig({
  displayName: "Headline___StyledHeading",
  componentId: "sc-1saf4hm-0"
})(["text-align:center;"]);

function Headline(props) {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledHeading, _objectSpread({
    m: 3,
    fontSize: [3, 4],
    fontWeight: "normal",
    lineHeight: "copy",
    fontFamily: "serif"
  }, props));
}

/* harmony default export */ var Atoms_Headline = (Headline);
// CONCATENATED MODULE: ./components/Molecules/Teaser.js












var _StyledSimpleImg = Object(styled_components_browser_esm["default"])(lib["SimpleImg"]).withConfig({
  displayName: "Teaser___StyledSimpleImg",
  componentId: "do3gtn-0"
})(["box-shadow:4px 4px 6px -6px ", ";"], function (props) {
  return props.theme.black;
});

function Teaser(_ref) {
  var post = _ref.post;
  var teaserImage = Object(wordpress["c" /* getImageSize */])(post.featuredImage.node.mediaDetails.sizes, "post-thumbnail");

  if (!teaserImage) {
    teaserImage = Object(wordpress["c" /* getImageSize */])(post.featuredImage.node.mediaDetails.sizes, "thumbnail");
  }

  if (!teaserImage) {
    teaserImage = Object(wordpress["c" /* getImageSize */])(post.featuredImage.node.mediaDetails.sizes, "img-8080");
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(dist["Box"], {
    px: 1,
    py: 2,
    width: [1 / 2, 1 / 4],
    as: "article",
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
      href: Object(util_link["a" /* cleanupLink */])(post.link),
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
        alt: post.title,
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledSimpleImg, {
          src: Object(wordpress["f" /* uriWithRevision */])(teaserImage.sourceUrl, post.revisionCount),
          alt: post.title,
          width: teaserImage.width,
          height: teaserImage.height,
          applyAspectRatio: true
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Atoms_Headline, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: Object(util_link["a" /* cleanupLink */])(post.link),
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
          alt: post.title,
          children: Object(markup["a" /* cleanupMarkup */])(post.title)
        })
      })
    })]
  });
}

/***/ }),

/***/ "vbcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Query; });
/* unused harmony export Subscription */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mrSG");
/* harmony import */ var _apollo_react_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ttZb");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





function Query(props) {
    var children = props.children, query = props.query, options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __rest */ "f"])(props, ["children", "query"]);
    var result = Object(_apollo_react_hooks__WEBPACK_IMPORTED_MODULE_1__[/* useQuery */ "c"])(query, options);
    return children && result ? children(result) : null;
}
(function (Query) {
    Query.propTypes = {
        client: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
        children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
        fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        notifyOnNetworkStatusChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onError: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        pollInterval: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
        query: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object.isRequired,
        variables: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
        ssr: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        partialRefetch: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        returnPartialData: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool
    };
})(Query || (Query = {}));

function Mutation(props) {
    var _a = Object(_apollo_react_hooks__WEBPACK_IMPORTED_MODULE_1__[/* useMutation */ "b"])(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function (Mutation) {
    Mutation.propTypes = {
        mutation: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object.isRequired,
        variables: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
        optimisticResponse: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func]),
        refetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
            prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object])),
            prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
        ]),
        awaitRefetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        update: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
        onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onError: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
    };
})(Mutation || (Mutation = {}));

function Subscription(props) {
    var result = Object(_apollo_react_hooks__WEBPACK_IMPORTED_MODULE_1__[/* useSubscription */ "d"])(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function (Subscription) {
    Subscription.propTypes = {
        subscription: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object.isRequired,
        variables: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
        children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onSubscriptionData: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onSubscriptionComplete: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        shouldResubscribe: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool]),
    };
})(Subscription || (Subscription = {}));


//# sourceMappingURL=react-components.esm.js.map


/***/ })

}]);